import Button from '@gaia/components/Button';
import convertTrackPointToWaypoint from '@gaia/utils/gaia/convertTrackPointToWaypoint';
import removeTrackPoint from '@gaia/utils/gaia/removeTrackPoint';
import type {ControlPointPopupProps} from '@map/Map/useControlPointPopup';
import PopupCloseButton from '@map/popups/PopupCloseButton';

export function TrackPointPopup({
    onOverlaysChange,
    overlays,
    selection: {localId},
    setSelections,
    onInteractionChange,
    interaction,
}: ControlPointPopupProps & {selection: WaypointSelectionState}) {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                marginBottom: '-5px', // override default margin on mapbox GL JS popup
                alignItems: 'stretch',
            }}
        >
            <PopupCloseButton onClick={() => setSelections([])} />
            <Button
                appearance='destruct'
                iconName='delete'
                onClick={() => {
                    if (interaction.type !== 'editingRoute') return;
                    const updatedTrack = removeTrackPoint(localId, interaction.track);
                    if (!updatedTrack) return;

                    onInteractionChange({...interaction, track: updatedTrack});
                    setSelections([]);
                }}
                size='small'
                style={{justifyContent: 'left'}}
            >
                Delete Point
            </Button>
            <Button
                iconName='add-waypoint'
                onClick={() => {
                    if (interaction.type !== 'editingRoute' || !interaction.track.isGeometryLoaded)
                        return;
                    onOverlaysChange({...overlays, showWaypoints: true});
                    const updatedTrack = convertTrackPointToWaypoint(localId, interaction.track);
                    onInteractionChange({...interaction, track: updatedTrack});
                    setSelections([]);
                }}
                size='small'
                style={{justifyContent: 'left'}}
            >
                Add Waypoint
            </Button>
        </div>
    );
}
